import Masthead from "./masthead";

export const General = {

  init: function() {
    // use bootstrap error classes for jQuery validator
    // http://stackoverflow.com/a/19006517/1295219
    $.validator.setDefaults({
      errorElement: "span",
      errorClass: "help-block customized",
      highlight: function (element, errorClass, validClass) {
          $(element).closest('.form-group').addClass('has-error');
      },
      unhighlight: function (element, errorClass, validClass) {
          $(element).closest('.form-group').removeClass('has-error');
      },
      errorPlacement: function(error, element) {
        $(element).closest('.form-group').append(error);
      },
    });

    // Lazy load init.
    $("img").lazyload();

		// masthead search init
		if ( $(".masthead").length ){
			Masthead.init();
		}
  },

  // https://davidwalsh.name/javascript-debounce-function
  debounce: function(func, wait, immediate) {
    let timeout;
    return function() {
      let context = this, args = arguments;
      let later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      let callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

};

export const Flash = {

  success: function (msg) {
    $.notify({
      // options
      message: msg
    }, {
      // settings
      element: '#flash-messages',
      type: 'success',
      position: 'fixed',
      delay: 5000,
      allow_dismiss: true,
      onShown: function() {
        // so it wont get animated again with turbolinks page visit
        $(this).removeClass('animated');
      }
    });
  },

  error: function (msg) {
    $.notify({
      // options
      message: msg
    }, {
      // settings
      element: '#flash-messages',
      position: 'fixed',
      type: 'danger',
      delay: 1000000,
      timer: 1000000,
      allow_dismiss: true,
      onShown: function() {
        // so it wont get animated again with turbolinks page visit
        $(this).removeClass('animated');
      }
    });
  }
}
